import { render } from "./HeroiconsSolidLockClosed.vue?vue&type=template&id=9ae7e13a"
const script = {}

import exportComponent from "/www/brandsecurity_2/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidLockClosed.vue"]])

export default __exports__